export const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const toFlexibleSeparatorPattern = (name: string) =>
  escapeRegExp(name).replace(/ /g, '[ _]');

export const toLowerCaseSet = <T extends string | undefined>(
  values: Iterable<T>
) => new Set(Array.from(values, (value) => value?.toLowerCase()));
